module.exports = __webpack_public_path__ + "img/PMagus64_ua.7afa5209.webp";